/* Progressive enhancement only: native Shopify forms work without JavaScript. */
(() => {
  const mount = (root = document) => {
    root.querySelectorAll('[data-bj-qa-variant]').forEach(select => {
      if (select.dataset.bjReady === '1') return;
      select.dataset.bjReady = '1';
      const price = select.closest('.bj-qa-product__details')?.querySelector('[data-bj-qa-price]');
      const sync = () => {
        const chosen = select.selectedOptions[0];
        if (chosen && price) price.textContent = chosen.dataset.price || '';
      };
      select.addEventListener('change', sync);
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), {once:true});
  else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
